import { array } from "prop-types";
import "toastr/build/toastr.min.css";
import { toast } from "react-toastify";
import { FIND_COMPANY_USER } from "../config/apiEndPoint";
import { GET, POST } from "config/api.config";

export const getFindCompanyUserList = async (data = array()) => {
  try {
    const url = data?._Id
      ? `${FIND_COMPANY_USER.GET_FIND_COMPANY_USER_LIST}/${data?._Id}`
      : `${FIND_COMPANY_USER.GET_FIND_COMPANY_USER_LIST}`;
    const response = await GET(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const fetchFindCompanyUserTableAndFilterSchema = async (data = array()) => {
  try {
    const url = data?._Id
      ? `${FIND_COMPANY_USER.GET_FIND_COMPANY_USER_SCHEMA}/${data?._Id}`
      : `${FIND_COMPANY_USER.GET_FIND_COMPANY_USER_SCHEMA}`;
    const response = await GET(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const submitFindCompanyUserFilterData = async (data = array()) => {
  try {
    const response = await POST(FIND_COMPANY_USER.SUBMIT_FILTER_DATA, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};
